import Logo from 'src/common/ui-kit/Logo'

import ConnectWallet from '../ConnectWallet/ConnectWallet'

import './styles.css'
import NavBar from './components/NavBar'

export interface HeaderProps {
  className?: string
}

const Header: React.FC<HeaderProps> = props => {
  return (
    <div className={`comp-header ${props.className}`}>
      <div className='comp-header-left-wrap'>
        <Logo />
        <NavBar />
      </div>
      <div className='comp-header-right-wrap'>
        <ConnectWallet />
      </div>
    </div>
  )
}

export default Header
